import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";

export const useUnionFilter = () => {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			id: "union",
			Header: t("union"),
			filter: "resource-select",
			canFilter: true,
			Filter: (
				<ResourceSelect
					labelPropName="description"
					renderLabel={renderSettingsResourceLabel}
					resourcePath="/union"
					hasSearch
					mode="multiple"
					getSearchFilters={getSettingsResourceSearchFilters}
				/>
			),
		}),
		[t],
	);
};
